import { api } from '@/api/client';

export function getPersonNotesQueryOptions(personId: string) {
  return {
    queryKey: ['personNotes', personId] as const,
    queryFn: () => api.persons.listNotes(personId),
    staleTime: 60_000,
  };
}
